import Vue from 'vue'

export default {
    namespaced: true,

    state: {
        talents: [],
        deliverable_formats: [],
        loading: false
    },

    getters: {
        languages: state => {
            let language = state.talents.find(item => item.slug === 'language')
            return state.talents.filter(item => item.parent === language.id)
        },
        applications: state => {
            let application = state.talents.find(item => item.slug === 'application_type')
            return state.talents.filter(item => item.parent === application.id)
        },
        formats: state => {
            let application = state.deliverable_formats.find(item => item.slug === 'format')
            return state.deliverable_formats.filter(item => item.parent === application.id)
        },
        systemProviders: state => {
            let application = state.deliverable_formats.find(item => item.slug === 'system_provider')
            return state.deliverable_formats.filter(item => item.parent === application.id)
        }
    },

    mutations: {
        setTalents (state, items) {
            state.talents = items
        },
        setDeliverableFormats (state, items) {
            state.deliverable_formats = items
        },
        toggleLoading (state, loading) {
            state.loading = loading
        }
    },

    actions: {
        fetch: async ({dispatch, state}, data) => {
            try {            
                dispatch('fetchTalents')
                dispatch('fetchDeliverableFormats')
            } catch (ex) {
                console.log(ex)
            }
        },
        
        fetchTalents: async ({commit}) => {
            try {            
                let uri = '/talents/tags'

                const res = await Vue.axios.get(uri, {params: {hide_empty: false}});

                commit('setTalents', res.data.records)
            } catch (ex) {
                console.log(ex)
            }
        },

        fetchDeliverableFormats: async ({commit}) => {
            try {            
                let uri = '/deliverable_formats/tags'

                const res = await Vue.axios.get(uri, {params: {hide_empty: false}});

                commit('setDeliverableFormats', res.data.records)
            } catch (ex) {
                console.log(ex)
            }
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./prompts/store/modules/Tag.js
// module id = null
// module chunks = 